import { render, staticRenderFns } from "./EditAdvertising.html?vue&type=template&id=e70dac8a&scoped=true&"
import script from "./EditAdvertising.vue?vue&type=script&lang=js&"
export * from "./EditAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./EditAdvertising.scss?vue&type=style&index=0&id=e70dac8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70dac8a",
  null
  
)

export default component.exports